import React, { lazy, memo } from 'react';
import { StarIcon, ClockIcon, DollarSignIcon, BriefcaseIcon } from 'lucide-react';
const Testimonials = () => {
  const testimonials = [{
    id: 1,
    quote: 'No solo me quitó el dolor, me devolvió la semana.',
    name: 'María G.',
    location: 'Barcelona',
    stars: 5,
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=761&q=80'
  }, {
    id: 2,
    quote: 'Ahora trabajo sin miedo al dolor.',
    name: 'Carlos P.',
    location: 'Madrid',
    stars: 5,
    image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1148&q=80'
  }, {
    id: 3,
    quote: 'Es mi salvavidas diario.',
    name: 'Laura M.',
    location: 'Sevilla',
    stars: 5,
    image: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=686&q=80'
  }];
  // Pre-render stars array to avoid re-computation
  const renderStars = count => {
    return Array(count).fill(0).map((_, i) => <StarIcon key={i} size={16} className="text-[#f59e0b] fill-[#f59e0b]" data-id="element-438" />);
  };
  const featuredStars = Array(5).fill(0).map((_, i) => <StarIcon key={i} size={24} className="text-[#f59e0b] fill-[#f59e0b] mx-1" data-id="element-439" />);
  return <section id="testimonials" className="py-16 md:py-24 bg-white" data-id="element-440">
      <div className="container mx-auto px-4 md:px-6" data-id="element-441">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-442">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#1e293b]" data-id="element-443">
            Miles ya lo comprobaron
          </h2>
          <p className="text-xl text-[#4a5568]" data-id="element-444">
            Estas son solo algunas de las más de 12,000 personas que han
            recuperado su tiempo, energía y productividad
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-445">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-[#f8f9ff] rounded-xl shadow-md p-6 transition-all hover:shadow-lg hover:transform hover:scale-105" data-id="element-446">
              <div className="flex justify-between items-start mb-4" data-id="element-447">
                <div className="flex items-center" data-id="element-448">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4" width="48" height="48" loading="lazy" data-id="element-449" />
                  <div data-id="element-450">
                    <h4 className="font-semibold text-[#1e293b]" data-id="element-451">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-[#718096]" data-id="element-452">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-453">{renderStars(testimonial.stars)}</div>
              </div>
              <blockquote className="text-lg text-[#4a5568] italic" data-id="element-454">
                "{testimonial.quote}"
              </blockquote>
            </div>)}
        </div>
        <div className="mt-16 flex justify-center" data-id="element-455">
          <div className="bg-[#eef2ff] rounded-xl p-6 md:p-8 max-w-3xl" data-id="element-456">
            <div className="flex items-center justify-center mb-6" data-id="element-457">
              {featuredStars}
            </div>
            <p className="text-xl md:text-2xl text-center text-[#1e293b] font-medium" data-id="element-458">
              "Cada mes recupero casi 40 horas que antes perdía por el dolor. Es
              como haber contratado un asistente a tiempo completo, pero sin el
              costo."
            </p>
            <div className="mt-6 text-center" data-id="element-459">
              <h4 className="font-semibold text-[#1e293b]" data-id="element-460">Ana Rodríguez</h4>
              <p className="text-[#718096]" data-id="element-461">
                Empresaria, usuaria desde hace 6 meses
              </p>
            </div>
            <div className="mt-6 flex justify-center gap-8" data-id="element-462">
              <div className="flex flex-col items-center" data-id="element-463">
                <ClockIcon size={24} className="text-[#6366f1] mb-2" data-id="element-464" />
                <p className="text-[#4a5568] font-medium" data-id="element-465">40+ horas/mes</p>
                <p className="text-sm text-[#718096]" data-id="element-466">recuperadas</p>
              </div>
              <div className="flex flex-col items-center" data-id="element-467">
                <DollarSignIcon size={24} className="text-[#6366f1] mb-2" data-id="element-468" />
                <p className="text-[#4a5568] font-medium" data-id="element-469">$2,900 USD</p>
                <p className="text-sm text-[#718096]" data-id="element-470">ahorrados al año</p>
              </div>
              <div className="flex flex-col items-center" data-id="element-471">
                <BriefcaseIcon size={24} className="text-[#6366f1] mb-2" data-id="element-472" />
                <p className="text-[#4a5568] font-medium" data-id="element-473">3x</p>
                <p className="text-sm text-[#718096]" data-id="element-474">más productividad</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(Testimonials);